export enum BadgeKey {
  InsightsOverview = 'insights.overview',
  InsightsRecentInsights = 'insights.recentInsights',
  InsightsTopCustomerQuestions = 'insights.topCustomerQuestions',
}

export type BadgeValue = number;

export interface IBadgesState extends Partial<Record<BadgeKey, BadgeValue>> {}
